export function cloneObjectWithNoReference<T>(object:T): T {
    return JSON.parse(JSON.stringify(object));
}
